import { Component } from '@angular/core';

@Component({
  selector: 'business-type-skeleton-loader',
  templateUrl: './business-type-skeleton-loader.component.html',
  standalone: false,
})
export class BusinessTypeSkeletonLoaderComponent {}
